import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Indent from '../../Indent';
import { link, linkChangeColor, toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import BigText from '../../BigText';
import VimeoVideo from '../../VimeoVideo';
import Poster from '../../Poster';
import Carousel from '../../Carousel';
import Thumbs from '../../Thumbs';
import mq from '@/utils/media-queries';
import Triplet from '../../Triplet';
import LazyLoadDefault from '../../LazyLoadDefault';

const ITEM_MARGIN_BOTTOM = 72;
const ITEM_MARGIN_BOTTOM_BIG = 72;
const ITEM_MARGIN_BOTTOM_MD = 51;
const ITEM_MARGIN_BOTTOM_SM = 48;

const Styled = styled.div`
  margin-bottom: ${toVw(ITEM_MARGIN_BOTTOM)};

  &:last-child {
    margin-bottom: 0;
  }

  ${props =>
    props.bigMargins &&
    css`
      margin-top: ${toVw(ITEM_MARGIN_BOTTOM_BIG)};
      margin-bottom: ${toVw(ITEM_MARGIN_BOTTOM_BIG)};

      &:first-child {
        margin-top: 0;
      }
    `};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(ITEM_MARGIN_BOTTOM_MD)};

    ${props =>
      props.bigMargins &&
      css`
        margin-top: ${toVwTablet(ITEM_MARGIN_BOTTOM_MD)};
        margin-bottom: ${toVwTablet(ITEM_MARGIN_BOTTOM_MD)};
      `};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(ITEM_MARGIN_BOTTOM_SM)};

    ${props =>
      props.bigMargins &&
      css`
        margin-top: ${toVwMobile(ITEM_MARGIN_BOTTOM_SM)};
        margin-bottom: ${toVwMobile(ITEM_MARGIN_BOTTOM_SM)};
      `};
  `)};
`;

const Text = styled.p`
  width: ${toVw(738)};

  ${mq.tablet(css`
    width: ${toVwTablet(560)};
  `)};

  ${mq.mobile(css`
    width: 100%;
  `)};
`;

const FormattedText = styled.div`
  a {
    ${link};
    ${props => linkChangeColor(props.theme.colorText)};
  }
`;

class Item extends React.Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
  };

  renderItem(item) {
    switch (item.type) {
      case 'poster':
        return (
          <Styled>
            <LazyLoadDefault>
              <Poster {...item.content} />
            </LazyLoadDefault>
          </Styled>
        );
      case 'thumbs':
        return (
          <Styled>
            <LazyLoadDefault>
              <Thumbs {...item.content} />
            </LazyLoadDefault>
          </Styled>
        );
      case 'vimeo':
        return (
          <Styled>
            <LazyLoadDefault>
              <VimeoVideo {...item.content} />
            </LazyLoadDefault>
          </Styled>
        );
      case 'carousel':
        return (
          <Styled>
            <LazyLoadDefault>
              <Carousel {...item.content} alternativeAnimation showSlideBackground />
            </LazyLoadDefault>
          </Styled>
        );
      case 'text':
        return (
          <Styled bigMargins>
            <Indent>
              <Text>{item.content}</Text>
            </Indent>
          </Styled>
        );
      case 'formatted-text':
        return (
          <Styled>
            <Indent>
              <FormattedText dangerouslySetInnerHTML={{ __html: item.content }} />
            </Indent>
          </Styled>
        );
      case 'highlight':
        return (
          <Styled>
            <Indent>
              <BigText>{item.content}</BigText>
            </Indent>
          </Styled>
        );
      case 'triplet':
        return (
          <Styled>
            <LazyLoadDefault>
              <Triplet {...item.content} />
            </LazyLoadDefault>
          </Styled>
        );
      default:
        console.error('Unrecognized type of content:', item.type);
        return null;
    }
  }

  render() {
    return this.renderItem(this.props.item);
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/components/ContentItems/components/ContentItem.js